import {h} from 'preact';
import Fieldset from "./Fieldset";
import {renderFileRow} from "../../helper";

export default function FileInput(props){
	const hasFiles = Array.isArray(props.values[props.field]) && props.values[props.field].length;
	const fileList = hasFiles ? props.values[props.field].map((file, key) => renderFileRow(file, key, props.field, props.onDeleteFile, props.fileParams)):null;

	const subtext = props.subtext || 'Вложить файлы';

	return (
		<Fieldset hasErrors={props.errors[props.field]} title={props.getLabelField(props.field)} horizontal={props.horizontal||false}>
			<div className="file-input">
				<label className="file-input__body">
					<input className="file-input__input" multiple={true} type="file" onChange={props.onChangeFile(props.field)} value=''/>
					<span className="file-input__button button-primary button-primary_pdv_lg">
						<span>{hasFiles ? 'Добавить':'Выбрать'}</span>
					</span>
					<span className="file-input__file-name">
						<span className="file-input__text">{hasFiles ? `Файлов выбрано: ${hasFiles}`:'Файлы не выбраны'}</span>
					</span>
				</label>
			</div>
			<div className="file-input__subtext">{subtext} (размер файла не должен превышать 20 Мб)</div>
			{
				!!hasFiles &&
				<ul className="file-input__files-list">
					{
						fileList
					}
				</ul>
			}
		</Fieldset>
	)
}
